import useIsomorphicLayoutEffect from "@/hooks/useIsomorphicLayoutEffect"
import { useState } from "react"

export default function useGetFullUrl() {
	const [url, setUrl] = useState("")

	useIsomorphicLayoutEffect(() => {
		setUrl(window?.location?.href || "")
	}, [])

	return url
}
